import React, { createContext, useContext } from 'react'

interface ChartSlashCommandContextValue {
  forceRichDisplay?: boolean
}

const ChartSlashCommandContext = createContext<ChartSlashCommandContextValue>({
  forceRichDisplay: false,
})

export const useChartSlashCommandContext = () => {
  return useContext(ChartSlashCommandContext)
}

interface ChartSlashCommandProviderProps {
  forceRichDisplay?: boolean
  children: React.ReactNode
}

export const ChartSlashCommandProvider: React.FC<
  ChartSlashCommandProviderProps
> = ({ forceRichDisplay, children }) => {
  return (
    <ChartSlashCommandContext.Provider value={{ forceRichDisplay }}>
      {children}
    </ChartSlashCommandContext.Provider>
  )
}
